/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusStandortListResponseDto } from '../../models/lexplus-standort-list-response-dto';

export interface StandorteControllerFindAllPaginatedV1$Params {
  kundeId?: number;

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=standortID:DESC
 *
 *
 * **Default Value:** standortID:ASC
 *
 * **Available Fields**
 * - standortID
 */
  sortBy?: Array<'standortID:ASC' | 'standortID:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** 
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 */
  searchBy?: Array<string>;

/**
 * List of fields to select.
 *
 * **Example:** standortID,name,interneNotiz
 *
 *
 * **Default Value:** By default all fields returns. If you want to select only some fields, provide them in query param
 */
  select?: string;
}

export function standorteControllerFindAllPaginatedV1(http: HttpClient, rootUrl: string, params?: StandorteControllerFindAllPaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusStandortListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, standorteControllerFindAllPaginatedV1.PATH, 'get');
  if (params) {
    rb.query('kundeId', params.kundeId, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
    rb.query('select', params.select, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusStandortListResponseDto>;
    })
  );
}

standorteControllerFindAllPaginatedV1.PATH = '/v1/standorte/paginated';
